<template>
  <div>
    <div>
      <div class="max-w-5xl mx-auto">
        <div
          class="flex flex-wrap items-center justify-between -mt-2 -ml-4 sm:flex-no-wrap"
        >
          <div class="mt-2 ml-4">
            <h3 class="text-lg font-medium leading-6 text-gray-900">
              Menu
            </h3>
            <p class="mt-1 text-sm leading-5 text-gray-600">
              Crea i menu per tutte le tue esigenze: menu del giorni, carta dei
              vini, menu pranzo, cena...
            </p>
          </div>
          <div class="flex-shrink-0 mt-2 ml-4">
            <span class="inline-flex mr-2 rounded-md shadow-sm">
              <button
                @click="openTheme"
                type="button"
                class="inline-flex justify-center w-full px-4 py-2 text-base font-medium leading-6 text-white transition duration-150 ease-in-out bg-white bg-green-400 border rounded-md shadow-sm border-gray-50 hover:text-gray-50 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5 hover:bg-green-500 focus:border-green-400 focus:shadow-outline-green"
              >
                Personalizza
              </button>
            </span>
            <span class="inline-flex rounded-md shadow-sm">
              <router-link
                :to="{ name: 'MenuCreate', params: { id: this.id } }"
                type="button"
                class="relative inline-flex items-center px-4 py-2 text-sm font-medium leading-5 text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-indigo-700"
              >
                Crea nuovo
              </router-link>
            </span>
          </div>
        </div>
      </div>

      <div class="max-w-5xl mx-auto mt-5">
        <div class="flex flex-col">
          <div
            class="py-2 -my-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8"
          >
            <div
              class="inline-block min-w-full overflow-hidden align-middle border-b border-gray-200 shadow sm:rounded-lg"
            >
              <table class="min-w-full">
                <thead>
                  <tr>
                    <th
                      class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50"
                    >
                      Nome
                    </th>
                    <th
                      class="hidden px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 sm:table-cell bg-gray-50"
                    >
                      Numero piatti
                    </th>
                    <th
                      class="hidden px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 lg:table-cell bg-gray-50"
                    >
                      Visibilità agli utenti
                    </th>
                    <th
                      class="px-6 py-3 border-b border-gray-200 bg-gray-50"
                    ></th>
                  </tr>
                </thead>
                <draggable
                  v-model="menus"
                  :options="options"
                  @update="onDraggableUpdate"
                  tag="tbody"
                  class="bg-white"
                >
                  <router-link
                    tag="tr"
                    class="cursor-pointer hover:bg-gray-50"
                    :to="{
                      name: 'MenuCompose',
                      params: { id: id, idmenu: menu.id },
                    }"
                    v-for="menu in menus"
                    :key="menu.id"
                  >
                    <td class="px-6 py-4 border-b border-gray-200">
                      <div class="flex items-center">
                        <div class="flex-shrink-0 w-10 h-10">
                          <img
                            v-if="menu.url != null && menu.url != ''"
                            :src="getCategoryIcon(menu.url)"
                            class="w-10 h-10"
                            :alt="menu.name"
                          />

                          <div v-else class="w-10 h-10 rounded-full">
                            <svg
                              class="w-10 h-10"
                              height="512"
                              viewBox="0 0 128 128"
                              width="512"
                              xmlns="http://www.w3.org/2000/svg"
                              data-name="Layer 2"
                            >
                              <path
                                d="M20.333 14.667h87.333V126.25H20.333z"
                                fill="#efebe9"
                              />
                              <path
                                d="M58.965 39.122a8.893 8.893 0 00-8.429-8.2A8.769 8.769 0 0041.5 38.9l-1.13 12.788c-.386 4.352 1.481 7.781 4.748 9.018L43.442 89.82A6.8 6.8 0 1057 89.839l-1.672-29.133c3.267-1.237 5.133-4.666 4.748-9.018zM87.631 51.688l-.386-4.357V32.667a1.75 1.75 0 00-3.5 0v12.991h-4.218V32.667a1.75 1.75 0 00-3.5 0v12.991H71.81V32.667a1.75 1.75 0 00-3.5 0v14.664l-.386 4.357c-.385 4.352 1.482 7.781 4.748 9.018L71 89.819a6.8 6.8 0 1013.562.02l-1.679-29.133c3.265-1.237 5.133-4.666 4.748-9.018z"
                                fill="#dfccc9"
                              />
                              <path
                                d="M29.875 105h68.25v12.25h-68.25z"
                                fill="#fd7eb8"
                              />
                              <path
                                d="M20.333 14.667L94.25 1.75v12.917z"
                                fill="#a1887f"
                              />
                              <g fill="#271800">
                                <path
                                  d="M20.333 78.418a1.749 1.749 0 001.75-1.75v-7.5a1.75 1.75 0 00-3.5 0v7.5a1.75 1.75 0 001.75 1.75z"
                                />
                                <path
                                  d="M107.667 12.917H96V1.75A1.75 1.75 0 0093.949.026L20.032 12.942a1.784 1.784 0 00-1.449 1.725v40.166a1.75 1.75 0 003.5 0V16.417h83.834V124.5H22.083V91a1.75 1.75 0 00-3.5 0v35.25a1.751 1.751 0 001.75 1.75h87.334a1.75 1.75 0 001.75-1.75V14.667a1.749 1.749 0 00-1.75-1.75zm-67.152 0L92.5 3.833v9.084z"
                                />
                                <path
                                  d="M44.987 39.21a5.272 5.272 0 015.426-4.789 1.75 1.75 0 00.123-3.5A8.769 8.769 0 0041.5 38.9l-1.13 12.788c-.386 4.352 1.481 7.781 4.748 9.018L43.442 89.82A6.8 6.8 0 1057 89.839l-1.672-29.133c3.267-1.237 5.133-4.666 4.748-9.018l-1.111-12.566a1.75 1.75 0 10-3.486.308L56.59 52c.1 1.194.177 5.129-3.348 5.653a1.75 1.75 0 00-1.49 1.832l1.759 30.575a3.262 3.262 0 01-.878 2.476 3.374 3.374 0 01-4.82 0 3.275 3.275 0 01-.877-2.5l1.758-30.56a1.75 1.75 0 00-1.49-1.832c-3.525-.519-3.454-4.454-3.348-5.644zM70.06 30.917a1.75 1.75 0 00-1.75 1.75v14.664l-.386 4.357c-.385 4.352 1.482 7.781 4.748 9.018L71 89.819a6.8 6.8 0 1013.562.02l-1.679-29.133c3.265-1.237 5.133-4.666 4.748-9.018l-.386-4.357V32.667a1.75 1.75 0 00-3.5 0v12.991h-4.218V32.667a1.75 1.75 0 00-3.5 0v12.991H71.81V32.667a1.751 1.751 0 00-1.75-1.75zM80.8 57.649a1.75 1.75 0 00-1.49 1.832l1.758 30.58a3.259 3.259 0 01-.878 2.474 3.374 3.374 0 01-4.82 0 3.28 3.28 0 01-.877-2.5l1.758-30.56a1.75 1.75 0 00-1.49-1.832c-3.527-.517-3.456-4.453-3.351-5.643l.251-2.838h12.233L84.145 52c.105 1.19.175 5.125-3.345 5.649zM28.125 105v12.25a1.751 1.751 0 001.75 1.75h68.25a1.75 1.75 0 001.75-1.75V105a1.75 1.75 0 00-1.75-1.75h-68.25a1.751 1.751 0 00-1.75 1.75zm3.5 1.75h64.75v8.75h-64.75z"
                                />
                              </g>
                            </svg>
                          </div>
                        </div>
                        <div class="ml-4">
                          <div
                            class="text-sm font-medium leading-5 text-gray-900"
                          >
                            {{ menu.name }}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td
                      class="hidden px-6 py-4 whitespace-no-wrap border-b border-gray-200 sm:table-cell"
                    >
                      <div class="text-sm leading-5 text-gray-900">
                        <span
                          v-if="menu.ndishes"
                          class="inline-flex px-2 text-xs font-semibold leading-5 text-teal-800 bg-teal-100 rounded-full"
                        >
                          {{ menu.ndishes }}
                        </span>
                        <span
                          v-else
                          class="inline-flex px-2 text-xs font-semibold leading-5 text-teal-800 bg-teal-100 rounded-full"
                        >
                          0
                        </span>
                      </div>
                    </td>

                    <td
                      class="hidden px-6 py-4 text-sm font-medium leading-5 border-b border-gray-200 lg:table-cell"
                    >
                      <div
                        class=""
                        :class="menu.enable ? 'flex justify-between' : ''"
                      >
                        <router-link
                          :to="{
                            name: 'Menu',
                            params: { id: id, idmenu: menu.id },
                          }"
                          v-if="
                            menu.enable &&
                              (menu.is_hotel == 0 ||
                                (menu.is_hotel == 1 && menu.is_room_service))
                          "
                          class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium leading-4 bg-indigo-50 text-indigo-800"
                        >
                          <svg
                            class="mr-1.5 h-2 w-2 text-indigo-400"
                            fill="currentColor"
                            viewBox="0 0 8 8"
                          >
                            <circle cx="4" cy="4" r="3" />
                          </svg>
                          <span v-html="getScheduleString(menu)"></span>
                        </router-link>

                        <div
                          v-if="
                            menu.enable &&
                              menu.is_hotel == 1 &&
                              menu.is_room_service == 0
                          "
                        >
                          <router-link
                            :to="{ name: 'OrdersSettingsHotel' }"
                            class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium leading-4 bg-indigo-50 text-indigo-800"
                            >Visualizza orari</router-link
                          >
                        </div>

                        <div class="flex justify-end">
                          <!--
                          <div v-html="getScheduleString(menu)" class="px-2 mr-4 text-center text-indigo-600 rounded-md">
                          </div>
                          -->

                          <span
                            @click.stop="toogle(menu)"
                            :class="
                              menu.enable ? 'bg-indigo-600' : 'bg-gray-200'
                            "
                            role="checkbox"
                            tabindex="0"
                            aria-checked="false"
                            class="relative flex-shrink-0 inline-block h-6 transition-colors duration-200 ease-in-out bg-gray-200 border-2 border-transparent rounded-full cursor-pointer w-11 focus:outline-none focus:shadow-outline"
                          >
                            <!-- On: "translate-x-5", Off: "translate-x-0" -->
                            <span
                              aria-hidden="true"
                              :class="
                                menu.enable ? 'translate-x-5' : 'translate-x-0'
                              "
                              class="inline-block w-5 h-5 transition duration-200 ease-in-out transform translate-x-0 bg-white rounded-full shadow"
                            ></span>
                          </span>
                        </div>
                      </div>
                    </td>
                    <td
                      class="px-6 py-4 text-sm font-medium leading-5 text-right whitespace-no-wrap border-b border-gray-200"
                    >
                      <div class="relative inline-block text-left">
                        <div>
                          <span class="rounded-md shadow-sm">
                            <router-link
                              :to="{
                                name: 'Menu',
                                params: { id: id, idmenu: menu.id },
                              }"
                              type="button"
                              class="inline-flex justify-center w-full px-2 py-1 text-xs font-medium leading-5 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800 hover:bg-gray-100"
                              id="options-menu"
                              aria-haspopup="true"
                              aria-expanded="true"
                            >
                              Impostazioni
                            </router-link>
                          </span>
                        </div>
                      </div>
                      <!--
                      <router-link 
                        class="text-indigo-600 hover:text-indigo-900"
                        :to="{ name: 'MenuCompose', params:{ id: id, idmenu: menu.id }}">
                        Modifica
                      </router-link>
                      -->
                    </td>
                  </router-link>
                </draggable>
              </table>
              <div v-if="showEmpty">
                <div
                  class="inline-block min-w-full p-5 overflow-hidden text-center align-middle bg-white"
                >
                  <div class="mx-auto">
                    <div
                      class="flex items-center justify-center flex-shrink-0 mx-auto rounded-full"
                    >
                      <svg
                        fill="none"
                        viewBox="0 0 286.001 286"
                        xmlns="http://www.w3.org/2000/svg"
                        width="286"
                        height="286"
                        class="w-12 h-12"
                      >
                        <defs>
                          <linearGradient
                            id="menub"
                            x1=".089"
                            y1=".068"
                            x2=".908"
                            y2=".94"
                            gradientUnits="objectBoundingBox"
                          >
                            <stop offset="0" stop-color="#30dbff"></stop>
                            <stop offset=".393" stop-color="#237ed5"></stop>
                            <stop offset="1" stop-color="#161daa"></stop>
                          </linearGradient>
                          <filter
                            id="menua"
                            x="0"
                            y="0"
                            width="286"
                            height="286"
                            filterUnits="userSpaceOnUse"
                          >
                            <feOffset dx="8" dy="15"></feOffset>
                            <feGaussianBlur
                              stdDeviation="5"
                              result="blur"
                            ></feGaussianBlur>
                            <feFlood flood-opacity=".161"></feFlood>
                            <feComposite operator="in" in2="blur"></feComposite>
                            <feComposite in="SourceGraphic"></feComposite>
                          </filter>
                        </defs>
                        <g filter="url(#menua)">
                          <path
                            data-name="dasch_menu"
                            d="M230 253H20a23 23 0 01-23-23V20A23 23 0 0120-3h210a23 23 0 0123 23v210a23 23 0 01-23 23zM64.471 61.03a7.9 7.9 0 00-7.894 7.894v149.187A7.9 7.9 0 0064.471 226h120.375a7.9 7.9 0 007.894-7.893V68.924a7.9 7.9 0 00-7.894-7.894zm96.708-37.506a7.925 7.925 0 00-2.485.4L82.1 49.19h86.96V31.424a7.9 7.9 0 00-7.882-7.9zm1.468 172.031H86.671a5.92 5.92 0 110-11.84h75.975a5.92 5.92 0 010 11.84zM115.9 171.874H87.486a5.92 5.92 0 110-11.84H115.9a5.92 5.92 0 110 11.84zm48.223-27.834H85.19a5.92 5.92 0 110-11.84h1.715a37.877 37.877 0 013.753-11.508 38.473 38.473 0 0116.572-16.572 37.876 37.876 0 0111.508-3.753V97.4a5.92 5.92 0 0111.84 0v2.966a37.877 37.877 0 0111.508 3.753 38.475 38.475 0 0116.572 16.572 37.88 37.88 0 013.753 11.508h1.714a5.92 5.92 0 010 11.84zm-39.468-32.291a26.581 26.581 0 00-25.7 20.451h51.4a26.581 26.581 0 00-25.697-20.451z"
                            transform="translate(10 3)"
                            fill="url(#menub)"
                          ></path>
                        </g>
                      </svg>
                    </div>
                  </div>

                  <p class="mt-1 text-base">
                    Non sono presenti menu, creane uno adesso!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalTheme
      v-if="modalTheme.show"
      :location_id="this.id"
      :eventclose="modalTheme.eventclose"
      :event="modalTheme.event"
    ></ModalTheme>
  </div>
</template>

<script>
import MenuService from "../apis/MenuService";
import draggable from "vuedraggable";
import IconService from "../apis/IconService";
import ModalTheme from "../components/ModalTheme";

export default {
  props: {
    id: Number,
  },
  components: {
    draggable,
    ModalTheme,
  },
  data() {
    return {
      menus: [],
      showEmpty: false,
      options: {
        disabled: false,
        delay: 200,
        touchStartThreshold: 5,
        delayOnTouchOnly: true,
      },
      action: this.$route.meta.action,
      modalTheme: {
        show: false,
        eventclose: "",
        event: "",
      },
    };
  },
  mounted() {
    MenuService.getMenus(this.id).then((response) => {
      this.menus = response.data;
      if (this.menus.length == 0) {
        this.showEmpty = true;
      }
    });
  },
  created() {},
  methods: {
    openTheme() {
      this.modalTheme.eventclose = "clickCloseThemes" + this.id;
      this.modalTheme.event = "clickSaveThemes" + this.id;
      this.modalTheme.show = true;

      this.$root.$on("clickCloseThemes" + this.id, () => {
        this.modalTheme.show = false;
      });

      this.$root.$on("clickSaveThemes" + this.id, () => {
        this.modalTheme.show = false;
      });
    },

    onDraggableUpdate() {
      this.$store.dispatch("updateSpinner", true);
      this.options.disabled = true;

      MenuService.updatePositions(this.id, { menus: this.menus })
        .then((response) => {
          console.log(response.data.data);
        })
        .finally(() => {
          this.options.disabled = false;
          this.$store.dispatch("updateSpinner", false);
        });
    },

    getCategoryIcon: function(url) {
      return IconService.getIconCat(url);
    },

    getScheduleString(menu) {
      if (menu.schedule != null) {
        let type = menu.schedule.scheduleType;
        let startendTime = ` (${menu.schedule.startTime}-${menu.schedule.endTime})`;
        let rawHtml = "";
        if (type === 0) {
          rawHtml += `
          <span class="text-gray-700">Ogni giorno</span>
          `;
        }

        if (type === 1) {
          let days = "";
          let order = menu.schedule.selectedWeekDays
            .slice()
            .sort(function(a, b) {
              return a - b;
            });

          for (let i = 0; i < order.length; i++) {
            if (i < order.length - 1)
              days += this.daysToSrting(order[i]) + ", ";
            else days += this.daysToSrting(order[i]);
          }
          rawHtml += `
          <span class="text-gray-700">${days}</span>
          `;
        }

        if (type === 2) {
          //wlet days = "";
          let date = [];

          let dateToday = new Date();
          for (let i = 0; i < menu.schedule.selectedDates.length; i++) {
            let split = menu.schedule.selectedDates[i].split("/");
            let parseDate = new Date(
              split[2] + "-" + split[1] + "-" + split[0]
            );

            date.push(parseDate);
          }
          date.sort(function(a, b) {
            return a - b;
          });

          let validDates = [];
          for (let i = 0; i < date.length; i++) {
            if (date[i] >= dateToday) {
              validDates = date.splice(i, date.length - i);
              break;
            }
          }
          if (validDates.length == 0) {
            validDates.push(date[date.length - 1]);
          }

          if (validDates.length === 1) {
            rawHtml += `
          <span class="text-gray-700">${validDates[0].getDate()}/${validDates[0].getMonth() +
              1}/${validDates[0].getFullYear()}</span>`;
          } else {
            rawHtml += `
          <span class="text-gray-700">${validDates[0].getDate()}/${validDates[0].getMonth() +
              1}/${validDates[0].getFullYear()}...<i class="text-gray-400">+${validDates.length -
              1}</i></span>`;
          }
        }
        return rawHtml + startendTime;
      }
      return "";
    },

    daysToSrting(index) {
      const daysOfWeek = ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"];
      return daysOfWeek[index];
    },

    toogle(menu) {
      this.$store.dispatch("updateSpinner", true);

      MenuService.updateStatus(this.id, menu.id, { enable: !menu.enable })
        .then(() => {
          menu.enable = !menu.enable;
        })
        .finally(() => {
          this.options.disabled = false;
          this.$store.dispatch("updateSpinner", false);
        });
    },
  },
};
</script>
